
import React, { useState, useEffect } from "react";
import { Button, Form, Row, Col, Pagination } from "react-bootstrap";
import axios from "axios";
import { TbFileTime } from "react-icons/tb";
import PayrollLayout from "../../Components/PayrollLayout.jsx";
const PayrollReport = () => {
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [counter, setCounter] = useState(0);
  const [showErrors, setShowErrors] = useState(false);
  const [payrollData, setPayrollData] = useState([]);
  const [showTable, setShowTable] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const calculateWorkingDays = (start, end) => {
    if (!start || !end) return 0;
    let startDateObj = new Date(start);
    let endDateObj = new Date(end);
    if (startDateObj > endDateObj) {
      const temp = startDateObj;
      startDateObj = endDateObj;
      endDateObj = temp;
    }
    let count = 0;
    const currentDate = new Date(startDateObj);

    while (currentDate <= endDateObj) {
      if (currentDate.getDay() !== 0) { // Exclude Sundays
        count++;
      }
      currentDate.setDate(currentDate.getDate() + 1);
    }
    return count;
  };
  useEffect(() => {
    if (startDate && endDate) {
      try {
        const workingDays = calculateWorkingDays(startDate, endDate);
        setCounter(workingDays);
      } catch (error) {
        console.error("Error calculating working days:", error);
        setCounter(0);
      }
    } else {
      setCounter(0);
    }
  }, [startDate, endDate]);
  const handleChange = (e) => {
    const value = parseInt(e.target.value, 10);
    setCounter(isNaN(value) ? 0 : value);
  };
  const validateForm = () => {
    return startDate && endDate && counter > 0;
  };
  const handleGenerateReport = async () => {
    setShowErrors(true);
    if (!validateForm()) return;
    try {
      const response = await axios.post(
        "https://backend.ems.hiradentallab.com/api/payroll/generate-payroll",
        {
          startDate,
          endDate,
          workingDays: counter,
        }
      );
      setPayrollData(response.data.data);
      setShowTable(true);
    } catch (error) {
      console.error("Error generating payroll:", error);
    }
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    handleGenerateReport();
  };
  const handlePageChange = (page) => {
    setCurrentPage(page);
  };
  const totalPages = Math.ceil(payrollData.length / itemsPerPage);
  const pageRange = () => {
    const range = [];
    for (let i = 1; i <= totalPages; i++) {
      range.push(i);
    }
    return range;
  };
  const currentData = payrollData.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );
  const handleExportToExcel = () => {
    console.log("Exporting to Excel");
  };
  const handleExportToPDF = () => {
    console.log("Exporting to PDF");
  };
  // Calculate totals for footer
  const calculateTotal = (field) => {
    return currentData.reduce((sum, item) => sum + (item[field] || 0), 0);
  };
  return (
    <PayrollLayout>
      <h1 className="reports-title">
        <TbFileTime /> Generate Payroll
      </h1>
      <hr />
      <Form className="reports-form" onSubmit={handleSubmit}>
        <Row>
          <Col xs={12} md={4}>
            <Form.Group>
              <Form.Label htmlFor="start_date">
                Start date <span className="required">*</span> :
              </Form.Label>
              <Form.Control
                type="date"
                id="start_date"
                name="start_date"
                required
                value={startDate}
                onChange={(e) => setStartDate(e.target.value)}
                isInvalid={showErrors && !startDate}/>
              <Form.Control.Feedback type="invalid">
                {showErrors && !startDate ? "Start date is required" : ""}
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
          <Col xs={12} md={4}>
            <Form.Group>
              <Form.Label htmlFor="end_date">
                End date <span className="required">*</span> :
              </Form.Label>
              <Form.Control
                type="date"
                id="end_date"
                name="end_date"
                required
                value={endDate}
                onChange={(e) => setEndDate(e.target.value)}
                isInvalid={showErrors && !endDate}/>
              <Form.Control.Feedback type="invalid">
                {showErrors && !endDate ? "End date is required" : ""}
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
          <Col xs={12} md={4}>
            <Form.Group>
              <Form.Label htmlFor="working-days">
                Working Days<span className="required">*</span>
              </Form.Label>
              <Form.Control
                type="number"
                id="working-days"
                name="working-days"
                value={counter}
                onChange={handleChange}
                min="1"
                step="1"
                className="form-control"/>
            </Form.Group>
          </Col>
        </Row>
        <Button
          className="generate-report-button"
          type="submit"
          disabled={!validateForm()}>
          Generate Report
        </Button>
      </Form>
      {showTable && (
        <div className="emps-leave-report-table-container">
          <div className="table-actions">
            <Row className="w-100">
              <Col
                xs={12}
                md={6}
                className="d-flex align-items-center mb-3 justify-content-start">
                <Button
                  variant="secondary"
                  className="export-button"
                  onClick={handleExportToExcel}>
                  Excel
                </Button>
                <Button
                  variant="secondary"
                  className="export-button"
                  onClick={handleExportToPDF}
                  style={{ marginLeft: "10px" }}>
                  PDF
                </Button>
              </Col>
            </Row>
          </div>
          <div className="table-responsive">
            <table className="table table-striped">
              <thead className="table-header">
                <tr className="emps-payroll-table-header">
                  <th>SR</th>
                  <th>User ID</th>
                  <th>UserName</th>
                  <th>Name</th>
                  <th>Basic Salary</th>
                  <th>Total Working Days</th>
                  <th>Total Days Worked</th>
                  <th>Absent</th>
                  <th>Over Time</th>
                  <th>Final Salary</th>
                  <th>Start Date</th>
                  <th>End Date</th>
                </tr>
              </thead>
              <tbody>
                {currentData.map((data, index) => (
                  <tr key={index}>
                    <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>
                    <td>{data.userId}</td>
                    <td>{data.username}</td>
                    <td>{data.name}</td>
                    <td>{data.basicSalary.toFixed(2)}</td>
                    <td>{data.totalWorkingDays}</td>
                    <td>{data.totalDaysWorked}</td>
                    <td>{data.totalMinutesDeduction.toFixed(2)}</td>
                    <td>{data.extraMinutesBonus.toFixed(2)}</td>
                    <td>{data.finalSalary.toFixed(2)}</td>
                    <td>{new Date(data.startDate).toLocaleDateString()}</td>
                    <td>{new Date(data.endDate).toLocaleDateString()}</td>
                  </tr>
                ))}
              </tbody>
              <tfoot className="table-footer">
                <tr className="emps-payroll-table-footer">
                  <td>Total:</td>
                  <td>{currentData.length} employees</td>
                  <td></td>
                  <td></td>
                  <td>{calculateTotal('basicSalary').toFixed(2)}</td>
                  <td>{calculateTotal('totalWorkingDays')}</td>
                  <td>{calculateTotal('regularDaysWorked') + calculateTotal('holidayDaysWorked')}</td>
                  <td>{calculateTotal('totalMinutesDeduction').toFixed(2)}</td>
                  <td>{calculateTotal('extraMinutesBonus').toFixed(2)}</td>
                  <td>{calculateTotal('finalSalary').toFixed(2)}</td>
                  <td></td>
                  <td></td>
                </tr>
              </tfoot>
            </table>
            <div className="pagination-container">
              <Row>
                <Col xs={12} md={6} className="d-flex align-items-center">
                  <span>
                    Showing {currentPage} of {totalPages} Pages
                  </span>
                </Col>
                <Col xs={12} md={6} className="d-flex justify-content-end">
                  <Pagination>
                    <Pagination.Prev
                      onClick={() => handlePageChange(currentPage - 1)}
                      disabled={currentPage === 1}>
                      Previous
                    </Pagination.Prev>
                    {pageRange().map((page) => (
                      <Pagination.Item
                        key={page}
                        active={page === currentPage}
                        onClick={() => handlePageChange(page)}>
                        {page}
                      </Pagination.Item>
                    ))}
                    <Pagination.Next
                      onClick={() => handlePageChange(currentPage + 1)}
                      disabled={currentPage === totalPages}>
                      Next
                    </Pagination.Next>
                  </Pagination>
                </Col>
              </Row>
            </div>
          </div>
        </div>
      )}
    </PayrollLayout>
  );
};
export default PayrollReport;
